<template>
    <div class="partners-card__offer">
        <div class="partners-card__offer-tag">
            <span>{{ $t('landing.partners.tag.offer') }}</span>
        </div>
        <PrismicRichText :field="partner.offerTitle" class="partners-card__offer-title" />
        <PrismicRichText :field="partner.offerTitleTwo" class="partners-card__offer-title-two" />

        <div class="partners-card__offer-description">
            <PrismicRichText v-if="loggedIn" :field="partner.offerDescriptionLogged" />
            <PrismicRichText v-else :field="partner.offerDescriptionUnlogged" />
        </div>
        <div class="partners-card__offer-cta-container">
            <PrismicLink v-if="loggedIn" :field="partner.offerCtaLogged" class="partners-card__offer-cta">
                {{ partner.offerCtaLogged.text }}
            </PrismicLink>
            <PrismicLink v-else :field="partner.offerCtaUnlogged" class="partners-card__offer-cta" data-component-source="partners">
                {{ partner.offerCtaUnlogged.text }}
            </PrismicLink>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {PrismicLink, PrismicRichText} from '@prismicio/vue';
    import type {PartnersSliceDefaultPrimaryPartnersItem} from '@prismicio-types';
    import {storeToRefs} from 'pinia';
    import {useAuth} from '#imports';

    const props = defineProps<{
        partner: PartnersSliceDefaultPrimaryPartnersItem;
    }>();

    const auth = useAuth();
    const {loggedIn} = storeToRefs(auth);
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .partners-card {
        &__offer {
            position: relative;
            border: 1px solid var(--joy-color-primary-50);
            border-radius: var(--joy-core-radius-4);
            padding: var(--joy-core-spacing-5);
            letter-spacing: var(--joy-font-letter-spacing-tight);
            margin-top: var(--joy-core-spacing-7);

            &-tag {
                position: absolute;
                top: -16px;
                left: 10px;
                padding: var(--joy-core-spacing-1) var(--joy-core-spacing-5);
                border-radius: 56px;
                color: var(--joy-color-primary-50);
                border: 1px solid var(--joy-color-primary-50);
                background: var(--joy-color-background-default);
                transition: background-color var(--joy-transition-duration-long) var(--joy-transition-timing-function);
            }

            &-title,
            &-title-two {
                font-family: var(--joy-font-family-title);
                font-weight: var(--joy-font-weight-bold);
            }

            &-title {
                font-size: var(--joy-font-size-secondary-400);
            }

            &-title-two {
                font-size: var(--joy-font-size-primary-800);
                line-height: var(--joy-line-height-large);
                margin-bottom: var(--joy-core-spacing-3);
            }

            &-cta-container {
                a {
                    display: inline-block;
                    position: relative;
                    cursor: pointer;
                    bottom: 1px;
                    font-weight: var(--joy-font-weight-bold);
                    text-decoration: underline;
                    text-underline-position: under;
                    color: var(--joy-color-primary-50);
                    padding: 0 var(--joy-core-spacing-9) var(--joy-core-spacing-2) var(--joy-core-spacing-9);
                    transition: color var(--joy-transition-duration-default) var(--joy-transition-timing-function);

                    &:hover {
                        color: var(--joy-color-primary-70);
                    }
                }
            }

            &-description {
                margin-bottom: var(--joy-core-spacing-5);

                @include mq.screen_sm(min) {
                    max-height: 0;
                    overflow: hidden;
                    transition: max-height 0.2s ease-out;
                }
            }
        }
    }
</style>
